<template>
  <div>
    <navigation v-if="authenticated"></navigation>
    <div v-if="!authenticated">
      <router-view
        :logoSrc="logoSrc"
        :registerGraph="registerGraph"
      ></router-view>
    </div>
    <custom-modals v-if="authenticated"></custom-modals>
  </div>
</template>

<script>
import Navigation from './partials/Navigation';
import CustomModals from './partials/CustomModals';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: { Navigation, CustomModals },
  data() {
    return {
      logoSrc: '',
      registerGraph: '',
    };
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      program: 'getProgram',
    }),
  },
  mounted() {
    this.getProgramStyles();
  },
  methods: {
    getProgramStyles() {
      let program = this.program ?? this.$route.params.program;

      axios.get('/api/getStyles/' + program).then((response) => {
        this.logoSrc = response.data.logo_noBg;
        this.registerGraph = response.data.register_graph;
      });
    },
  },
};
</script>

<style>
.container {
  margin-top: 2rem;
}

.navbar {
  list-style-type: none;
}
.payu-info-credit {
  color: #008080;
}
</style>
